(function () {
  function prefillWithdrawalForm() {
    var params = new URLSearchParams(window.location.search);
    var orderNumber = params.get('order');
    if (!orderNumber) return;

    var inputs = document.querySelectorAll('input[type="text"], input[type="number"]');
    inputs.forEach(function (input) {
      var label = input.closest('label') ||
        document.querySelector('label[for="' + input.id + '"]');
      var labelText = label ? label.textContent.toLowerCase() : '';
      var placeholder = (input.placeholder || '').toLowerCase();
      var name = (input.name || '').toLowerCase();

      if (
        labelText.includes('order') ||
        placeholder.includes('order') ||
        name.includes('order')
      ) {
        input.value = orderNumber;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillWithdrawalForm);
  } else {
    prefillWithdrawalForm();
  }
  setTimeout(prefillWithdrawalForm, 1500);
})();
